import React from 'react'
import { Box } from '@mui/material'

function LogoBrand() {
  return (
    <Box sx={{ mt: 2.5, mb: 2.5, textAlign: 'center', p: '0px 20%' }}>
      <img src={window.location.origin + '/HR_Logo.png'} width="100%" alt="logo" />
      <p style={{ marginBottom: 0 }}>
        <b>
          Navigating the Post-pandemic HR Landscape: Enhancing Engagement, Retention, &amp; the
          Employee Experience{' '}
        </b>
      </p>
    </Box>
  )
}

export default LogoBrand
